export default __webpack_public_path__ + "static/media/logo_auth.edbceb7e.png";